module.exports = __webpack_public_path__ + "static/story4-01-533x800-1224d3296b2756490ed05c9d1179ff69.jpg";